import { render, staticRenderFns } from "./AddingRecord.vue?vue&type=template&id=bd6b5128&scoped=true"
import script from "./AddingRecord.vue?vue&type=script&lang=js"
export * from "./AddingRecord.vue?vue&type=script&lang=js"
import style0 from "./AddingRecord.vue?vue&type=style&index=0&id=bd6b5128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6b5128",
  null
  
)

export default component.exports